import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function OnboardingBodyPipelines() {
    return (
        <OnboardingBody title='What is a pipeline?'>
            <div>
                <p>
                    A pipeline is the series of stages that leads flow through — from step one to
                    the sale.
                </p>
                <p>
                    Once a lead enters a pipeline, Nutshell helps your team stay organized with
                    goals, tasks, and more.
                </p>
            </div>
        </OnboardingBody>
    );
}
